import React, { useState } from 'react';
import { Button } from '../ui/button';
import FundingAIAdvisorEmptyState from './FundingAIAdvisorEmptyState';
import FundingAIAdvisorPromptChips from './FundingAIAdvisorPromptChips';

const FundingAIAdvisorChat = ({
  messages,
  sending,
  onSend,
  hasClient,
  onGenerate,
}) => {
  const [draft, setDraft] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!draft.trim() || sending) return;
    const content = draft;
    setDraft('');
    await onSend(content);
  };

  return (
    <div className="flex h-full min-h-[480px] flex-col rounded-2xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)]">
      <div className="border-b border-[var(--fg-line)] px-4 py-3">
        <div className="text-sm font-semibold text-[var(--fg-text)]">Advisor chat</div>
        <div className="text-xs text-[var(--fg-muted)]">Recommended actions only — no automatic submissions or status changes.</div>
      </div>

      <div className="flex-1 space-y-3 overflow-y-auto px-4 py-4">
        {!messages?.length ? (
          <FundingAIAdvisorEmptyState hasClient={hasClient} onGenerate={onGenerate} />
        ) : (
          messages.map((message) => (
            <div
              key={message.id}
              className={`max-w-[90%] rounded-2xl px-4 py-3 text-sm ${
                message.role === 'user'
                  ? 'ml-auto bg-[var(--fg-accent)] text-white'
                  : 'bg-white text-[var(--fg-text)] dark:bg-slate-950/30'
              }`}
            >
              {message.content}
            </div>
          ))
        )}
      </div>

      <div className="border-t border-[var(--fg-line)] px-4 py-3">
        <FundingAIAdvisorPromptChips
          disabled={sending}
          onSelect={(prompt) => onSend(prompt)}
        />
        <form onSubmit={handleSubmit} className="mt-3 flex gap-2">
          <input
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Ask the funding advisor..."
            className="flex-1 rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20"
          />
          <Button type="submit" className="rounded-xl" disabled={sending || !draft.trim()}>
            {sending ? 'Sending...' : 'Send'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default FundingAIAdvisorChat;
